import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter, takeWhile } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private readonly router = inject(Router);

  private isFirstBrowserNavigation: boolean = true;

  constructor() {
    this.router.events
      .pipe(
        untilDestroyed(this),
        filter((event): event is NavigationStart => event instanceof NavigationStart),
        takeWhile(() => !this.isFirstBrowserNavigation, true)
      )
      .subscribe(event => {
        this.isFirstBrowserNavigation = event.id === 1;
      });
  }

  public getIsBrowserNavigation(): boolean {
    return this.isFirstBrowserNavigation;
  }
}
